var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Vue, Component } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import { LicenseState } from "@/app/store/modules/license.state";
import { LicenseStatus } from "@/app/api/battery-portal-api";
import moment from "moment";
// Key used to persist the dismissed state for the current browser session.
// sessionStorage keeps the flag across page refreshes but is cleared when
// the tab is closed. It is also explicitly cleared on successful login
// (see login.module.ts) so the banner reappears after a new sign-in.
export const LICENSE_BANNER_DISMISSED_KEY = "licenseBannerDismissed";
let LicenseWarningBanner = class LicenseWarningBanner extends Vue {
    constructor() {
        super(...arguments);
        this.dismissed = sessionStorage.getItem(LICENSE_BANNER_DISMISSED_KEY) === "true";
    }
    get showBanner() {
        if (this.dismissed)
            return false;
        return this.licenseState.status === LicenseStatus.InGracePeriod || this.licenseState.isDefaultLicense;
    }
    dismiss() {
        this.dismissed = true;
        sessionStorage.setItem(LICENSE_BANNER_DISMISSED_KEY, "true");
    }
    get bannerMessage() {
        var _a;
        if (this.licenseState.isClockTampered) {
            return "Clock tampering detected. System time appears to have been manipulated.";
        }
        if (this.licenseState.isDefaultLicense) {
            const days = (_a = this.licenseState.remainingDays) !== null && _a !== void 0 ? _a : 0;
            return `Default license active. ${days} day(s) remaining. Purchase a license to continue using the application.`;
        }
        // Grace period message
        return `Your license has expired. Features remain available until grace period concludes on ${this.gracePeriodEndDateFormatted}.`;
    }
    get gracePeriodEndDateFormatted() {
        const endDate = this.licenseState.endDate;
        const gracePeriodSecs = this.licenseState.gracePeriodSecs;
        if (!endDate || !gracePeriodSecs)
            return "N/A";
        const gracePeriodEndTimestamp = endDate + gracePeriodSecs;
        return moment.unix(gracePeriodEndTimestamp).format("DD MMM YYYY");
    }
    get canAccessAboutPage() {
        return this.loginState.isClientInstaller;
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], LicenseWarningBanner.prototype, "loginState", void 0);
__decorate([
    State("licenseModule"),
    __metadata("design:type", typeof (_b = typeof LicenseState !== "undefined" && LicenseState) === "function" ? _b : Object)
], LicenseWarningBanner.prototype, "licenseState", void 0);
LicenseWarningBanner = __decorate([
    Component({
        name: "LicenseWarningBanner"
    })
], LicenseWarningBanner);
export default LicenseWarningBanner;
